





































































































































































































































import { Component, Vue, PropSync, Prop } from "vue-property-decorator";
import { QuestoesGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestoesGuinchoModel";
import {
  COLISAO,
  CAPOTADO,
} from "@/models/cadastros/assistencia/guincho/MotivoServicoModel";
import {
  PARTES_DANIFICADAS,
  OUTROS,
} from "@/models/cadastros/assistencia/guincho/ParteDanificada";
import { MOTIVOS_SERVICO_GUINCHO } from "@/models/cadastros/assistencia/guincho/MotivoServicoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { ArquivoAnexoModel } from "@/models/cadastros/assistencia/guincho/ArquivoAnexoModel";
import { ValidationObserver } from "vee-validate";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { TipoLocalRemocaoList } from "@/models/cadastros/assistencia/TipoLocalRemocaoModel";
import { SimNaoList } from "@/models/cadastros/assistencia/SimNaoModel";
@Component({
  components: {
    GsModalDialog
  }
})
export default class QuestoesGuincho extends Vue {
  $refs!: {
    questoesGuinchoObserver: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ type: String, required: true })
  title!: string;

  @PropSync("questoesGuincho", { required: true })
  dadosSolicitacao!: QuestoesGuinchoModel;

  @Prop({ type: String, required: false })
  tpVeiculo!: string;

  motivosSolicitacao = MOTIVOS_SERVICO_GUINCHO;
  partesDanificadas = PARTES_DANIFICADAS;

  tiposPermitidos: string[]= ['jpg','png','gif','png','bmp']
  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  localRemocaoList =  TipoLocalRemocaoList;
  simNaoList = SimNaoList;
  get exibirInformacoesComplementares(): boolean {
    if (this.dadosSolicitacao.motivoSolicitacao) {
      return (
        this.dadosSolicitacao.motivoSolicitacao.codigo == COLISAO.codigo ||
        this.dadosSolicitacao.motivoSolicitacao.codigo == CAPOTADO.codigo
      );
    } else {
      return false;
    }
  }
  get exibirDescricaoParteDanificada() {
    return this.dadosSolicitacao.parteDanificada == OUTROS;
  }

  validarExtensao(extensaoArquivo:string) {
    const tipoFotoFiltro = this.tiposPermitidos.find(tipo => tipo == extensaoArquivo.toLowerCase());
    if(!tipoFotoFiltro) {
      return false;
    }
      return true;
  }

  handleFileUpload() {
    if (this.dadosSolicitacao.arquivoAtual) {
      this.dadosSolicitacao.arquivoAtual.forEach((foto) => {
        if(!this.validarExtensao(foto.name.split('.')[1])) {
          this.openDialog("Extensão inválida","Extensão de arquivo inválida usar jpg, gif, png, bmp.")
          this.dadosSolicitacao.arquivoAtual = []
          return
        }

       /* ServicosAssistenciaService
          .uploadFotos(foto)
          .then((res) => {
            this.dadosSolicitacao.fotosAcidente.push({
              arquivo: foto,
              UID: res.nomeArquivo,
            });
            this.dadosSolicitacao.arquivoAtual = undefined;
          })
          .catch((err) => {
            this.$refs.questoesGuinchoObserver.setErrors({
              upload: "Ocorreu um erro ao efetuar o upload da foto",
            });
          });*/
      });
    }
  }
  removerArquivo(arquivo: ArquivoAnexoModel) {
    this.dadosSolicitacao.fotosAcidente.splice(
      this.dadosSolicitacao.fotosAcidente.indexOf(arquivo),
      1
    );
  }

  private openDialog(title: string, message: string) {
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  closeDialog() {
    if (this.successDialog) {
      this.$router.push({ name: "HomePage" });
    }
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? '#00CD96' : 'error';
  }

  get btnText() {
    return this.successDialog ? 'Ok, entendi' : 'Fechar';
  }

  get dialogImg() {
    return this.successDialog ? 'success.png' : 'error.png';
  }
}
